import React from "react";
import { Card } from "antd";
import { useDraggable } from "@dnd-kit/react";
import {
    FIELD_LIBRARY_ITEMS,
    FieldLibraryItemId,
} from "app/pages/EarlyBirdOfferBuilder/fieldLibrary";

interface FieldLibraryProps {
    onFieldClick: (fieldId: FieldLibraryItemId) => void;
}

export const FieldLibrary: React.FC<FieldLibraryProps> = ({ onFieldClick }) => {
    return (
        <div style={{ padding: 16 }}>
            <h3>Field Library</h3>
            <p style={{ color: "#666", fontSize: 12, marginBottom: 12 }}>
                Drag fields into Include or Exclude to add conditions.
            </p>
            {FIELD_LIBRARY_ITEMS.map((item) => (
                <DraggableLibraryItem
                    key={item.id}
                    id={item.id}
                    label={item.label}
                    description={item.description}
                    onClick={() => onFieldClick(item.id)}
                />
            ))}
        </div>
    );
};

function DraggableLibraryItem({
    id,
    label,
    description,
    onClick,
}: {
    id: FieldLibraryItemId;
    label: string;
    description: string;
    onClick: () => void;
}) {
    const { ref, isDragging } = useDraggable({
        id: `library-${id}`,
        data: { fieldId: id },
    });

    return (
        <div ref={ref as any}>
            <Card
                size="small"
                style={{
                    marginBottom: 8,
                    cursor: "grab",
                    opacity: isDragging ? 0.5 : 1,
                }}
                onClick={onClick}
            >
                <div style={{ fontWeight: 500 }}>{label}</div>
                <div style={{ fontSize: 12, color: "#666" }}>{description}</div>
            </Card>
        </div>
    );
}